import { useCallback, useMemo } from "react";
import { useRouter, useSearchParams } from "next/navigation";

export const useSearchPageParams = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const params = useMemo(
    () => new URLSearchParams(searchParams),
    [searchParams],
  );

  const updateUrl = useCallback(
    ({
      searchTerm,
      animationPage,
      userPage,
    }: {
      searchTerm?: string;
      animationPage?: string;
      userPage?: string;
    }) => {
      if (searchTerm) {
        params.set("q", searchTerm);
      }
      if (animationPage) {
        params.set("ao", animationPage);
      }
      if (userPage) {
        params.set("uo", userPage);
      }

      router.replace(`/search?${params}`);
    },
    [params, router],
  );

  return {
    params,
    updateUrl,
    searchTerm: params.get("q"),
    animationPage: parseInt(params.get("ao") ?? "1", 10),
    userPage: parseInt(params.get("uo") ?? "1", 10),
  };
};
